import { useDispatch } from 'react-redux';

import { AppDispatch } from '@lib/core/service/types/appStateType';

export const useTypedDispatch = () => useDispatch<AppDispatch>();
